"use client";

let stripePromise: Promise<any> | null = null;

export function getStripe() {
  if (!stripePromise) {
    stripePromise = (async () => {
      try {
        const { loadStripe } = await import('@stripe/stripe-js');
        const key = process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY || '';
        if (!key) return null;
        return loadStripe(key);
      } catch {
        console.warn('Stripe.js not available');
        return null;
      }
    })();
  }
  return stripePromise;
}

export interface CheckoutItem {
  itemId: string;
  title: string;
  description?: string;
  price: number; // in smallest currency unit (cents/öre)
  currency: string; // ISO 4217
  quantity: number;
  imageUrl?: string;
}

// Creates a checkout session via API route, returns session URL
/** `returnPath` (a /marketplace/<item> page) brings a paying fan back to the
 *  item with ?paid=<session> — pay-what-you-feel downloads unlock there. */
export async function createCheckoutSession(items: CheckoutItem[], customerEmail?: string, buyerUid?: string, opts?: { returnPath?: string }): Promise<string | null> {
  try {
    const res = await fetch('/api/checkout', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items, customerEmail, buyerUid, returnPath: opts?.returnPath }),
    });
    const data = await res.json();
    if (data.url) return data.url;
    throw new Error(data.error || 'Failed to create checkout');
  } catch (err) {
    console.error('Stripe checkout error:', err);
    return null;
  }
}

// Redirect to Stripe checkout
export async function redirectToCheckout(items: CheckoutItem[], customerEmail?: string, buyerUid?: string, opts?: { returnPath?: string }) {
  const url = await createCheckoutSession(items, customerEmail, buyerUid, opts);
  if (url) {
    window.location.href = url;
  }
}
